import React from 'react';
import { Instagram, Mail, Phone, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-gold/10 py-16 lg:py-20">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          
          {/* Brand & Adresse */}
          <div>
            <h3 className="text-2xl font-bold text-gold mb-4">Bad Girl's Society</h3>
            <address className="not-italic text-white/70 leading-relaxed text-base mb-4">
              <strong className="text-white">Bad Girl's Society</strong><br/>
              Auf d. Driesch 19<br/>
              51107 Köln<br/>
              Deutschland
            </address>
          </div>

          {/* Kontakt */}
          <div>
            <h4 className="text-xl font-semibold text-white mb-4">Kontakt</h4>
            <div className="space-y-3">
              <a 
                href="tel:+491634630719" 
                className="flex items-center gap-3 text-white/70 hover:text-gold transition-colors group"
              >
                <div className="w-10 h-10 bg-gold/10 rounded-full flex items-center justify-center group-hover:bg-gold/20 transition-colors">
                  <Phone size={18} className="text-gold" />
                </div>
                <span>+49 163 4630719</span>
              </a>
              
              <a 
                href="mailto:info.bad.girl@web.de" 
                className="flex items-center gap-3 text-white/70 hover:text-gold transition-colors group"
              >
                <div className="w-10 h-10 bg-gold/10 rounded-full flex items-center justify-center group-hover:bg-gold/20 transition-colors">
                  <Mail size={18} className="text-gold" />
                </div>
                <span>info.bad.girl@web.de</span>
              </a>
            </div>
          </div>

          {/* Öffnungszeiten */}
          <div>
            <h4 className="text-xl font-semibold text-white mb-4 flex items-center gap-2">
              <Clock size={20} className="text-gold" />
              Öffnungszeiten
            </h4>
            <div className="space-y-2 text-white/70 text-base">
              <p><span className="text-white">Mo–Mi:</span> 10:00–20:00 Uhr</p>
              <p><span className="text-white">Do–Fr:</span> 10:00–18:00 Uhr</p>
              <p><span className="text-white">Sa–So:</span> geschlossen</p>
            </div>
          </div>

          {/* Navigation & Social */}
          <div>
            <h4 className="text-xl font-semibold text-white mb-4">Links</h4>
            <ul className="space-y-3">
              <li>
                <a href="#services" className="text-white/70 hover:text-gold transition-colors">
                  Leistungen
                </a>
              </li>
              <li>
                <a href="#process" className="text-white/70 hover:text-gold transition-colors">
                  Ablauf
                </a>
              </li>
              <li>
                <a href="#tiktok-live" className="text-white/70 hover:text-gold transition-colors">
                  TikTok LIVE
                </a>
              </li>
              <li>
                <a href="#faq" className="text-white/70 hover:text-gold transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#contact-form" className="text-white/70 hover:text-gold transition-colors">
                  Bewerbung
                </a>
              </li>
              <li>
                <a href="/impressum" className="text-white/70 hover:text-gold transition-colors">
                  Impressum
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Media Links - KORREKT getrennt mit rel="me" */}
        <div className="border-t border-gold/10 pt-8 mb-8">
          <h4 className="text-xl font-semibold text-white mb-4">Social Media</h4>
          <div className="flex flex-wrap gap-4">
            <a 
              href="https://www.instagram.com/bad.girl.society" 
              rel="me"
              target="_blank"
              className="flex items-center gap-3 text-white/70 hover:text-gold transition-colors group"
            >
              <div className="w-10 h-10 bg-gold/10 rounded-full flex items-center justify-center group-hover:bg-gold/20 transition-colors">
                <Instagram size={20} className="text-gold" />
              </div>
              <span>Instagram: @bad.girl.society</span>
            </a>

            <a 
              href="https://www.tiktok.com/@bg.societyy" 
              rel="me"
              target="_blank"
              className="flex items-center gap-3 text-white/70 hover:text-gold transition-colors group"
            >
              <div className="w-10 h-10 bg-gold/10 rounded-full flex items-center justify-center group-hover:bg-gold/20 transition-colors">
                <svg 
                  className="text-gold w-5 h-5" 
                  fill="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                </svg>
              </div>
              <span>TikTok: @bg.societyy</span>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gold/10 text-center">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} Bad Girl's Society. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
